import React, { Component } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Form,
  FormInput,
  FormGroup,
  Button,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "shards-react";

export default class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      username: "",
      password: "",
    };
  }

  handleSuccessfulAuth = (response) => {
    this.props.handleLogin(response);
    this.props.history.push("/nonverified");
  };

  handleUnsuccessfulAuth = (response) => {
    if (response.status === 404 || response.status === 401) {
      this.setState({
        message: response.data.message,
      });
    }
  };

  handleSubmit = (event) => {
    const { username, password } = this.state;
    this.setState({ loading: true });
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/admin/login`,
        {
          username: username,
          password: password,
        },
        { withCredentials: true }
      )
      .then((response) => {
        if (response.status === 200) {
          this.handleSuccessfulAuth(response);
        }
      })
      .catch((error) => {
        console.log(error);
        this.handleUnsuccessfulAuth(error.response);
        this.setState({ loading: false });
      });

    event.preventDefault();
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  render() {
    const { loading, username, password } = this.state;
    return (
      <Container id="home" fluid>
        <Row className="justify-content-center align-middle pt-5">
          <Col className="pt-5 mt-5">
            <Row className="justify-content-center">
              <h1 className="text-primary">Se connecter</h1>
            </Row>
            <Row className="justify-content-center mt-5">
              <Form onSubmit={this.handleSubmit}>
                <FormGroup>
                  <InputGroup className="mb-3">
                    <InputGroupAddon type="prepend">
                      <InputGroupText>
                        <i className="material-icons">person</i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <FormInput
                      id="username"
                      name="username"
                      type="text"
                      value={username}
                      placeholder="Username"
                      onChange={this.handleChange}
                      required
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup className="mb-3">
                    <InputGroupAddon type="prepend">
                      <InputGroupText>
                        <i className="material-icons">https</i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <FormInput
                      id="password"
                      name="password"
                      type="password"
                      value={password}
                      placeholder="Mot de pass"
                      onChange={this.handleChange}
                      required
                    />
                  </InputGroup>
                </FormGroup>

                <Row className="justify-content-center mt-5">
                  <Button
                    outline
                    theme="danger"
                    onClick={() => {
                      window.location = "/";
                    }}
                    className="mr-1"
                  >
                    Go Home
                  </Button>
                  <Button
                    type="submit"
                    outline
                    theme="primary"
                    disabled={loading}
                  >
                    {loading && <i className="fa fa-refresh fa-spin"></i>}
                    {loading && " Attendez s'il vous plaît"}
                    {!loading && "Connect"}
                  </Button>
                </Row>
                <Row className="justify-content-center mt-5">
                  <h5 className="text-danger">{this.state.message}</h5>
                </Row>
              </Form>
            </Row>
          </Col>
        </Row>
      </Container>
    );
  }
}
